// extracted by mini-css-extract-plugin
export default {"loadBlockDarkBg":"SearchBarPlaceholder__loadBlockDarkBg--dGhJ3"};